document.addEventListener('DOMContentLoaded', function () {
  /* This is to limit the delivery instructions on the cart/checkout page to 100 chars */
  /*
  function waitForElementById(id) {
    return new Promise(resolve => {
      if (document.getElementById(id)) {
        return resolve(document.getElementById(id));
      }

      const observer = new MutationObserver(mutations => {
        if (document.getElementById(id)) {
          observer.disconnect();
          resolve(document.getElementById(id));
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  // Usage with async/await
  async function executeAfterElement() {
    const element = await waitForElementById('gsAppContainer');
    const textareaItems = document.querySelectorAll('[id^="gsCartOptiona8cc784e-0315-4ca5-85a2-3e83dfe9fa38"]');
    console.dir(textareaItems);
    for (const item of textareaItems) {
      console.log("CUSTOM!");
      item.maxLength = 100;
    };
  }
  executeAfterElement();
  */ 
  
  
  /* LOGO SCROLLER */
  const container = document.querySelector('.logolist--inner');
  if (!container || container.dataset.cloned === 'true') return;

  const NORMAL_SPEED = 1.2;
  const SLOW_SPEED = 0.25;
  const STOP_SPEED = 0;
  let scrollX = 0;
  let speed = NORMAL_SPEED;
  let targetSpeed = NORMAL_SPEED;
  let isStopped = false;

  function animate() {
    scrollX -= speed;
    container.style.transform = `translateX(${scrollX}px)`;

    const containerWidth = container.scrollWidth / 2;
    if (Math.abs(scrollX) >= containerWidth) scrollX = 0;

    speed += (targetSpeed - speed) * 0.1;
    requestAnimationFrame(animate);
  }

  function cloneItems() {
    const items = Array.from(container.children).filter(el =>
      el.querySelector('img, svg')
    );
    items.forEach(item => {
      const clone = item.cloneNode(true);
      container.appendChild(clone);
    });
    container.dataset.cloned = 'true';
  }

  function startWhenImagesReady() {
    const images = container.querySelectorAll('img');
    let loadedCount = 0;

    function start() {
      if (!container.dataset.cloned) {
        cloneItems();
        animate();
      }
    }

    if (images.length === 0) return start();

    images.forEach(img => {
      if (img.complete) {
        loadedCount++;
      } else {
        img.addEventListener('load', () => {
          loadedCount++;
          if (loadedCount === images.length) start();
        });
        img.addEventListener('error', () => {
          loadedCount++;
          if (loadedCount === images.length) start();
        });
      }
    });

    if (loadedCount === images.length) start();

    setTimeout(start, 2000);
  }

  function initScrollOnView() {
    const observer = new IntersectionObserver((entries, obs) => {
      if (entries[0].isIntersecting) {
        obs.disconnect();
        startWhenImagesReady();

        if ('ontouchstart' in window === false) {
          container.addEventListener('mouseenter', () => {
            if (!isStopped) targetSpeed = SLOW_SPEED;
          });
          container.addEventListener('mouseleave', () => {
            if (!isStopped) targetSpeed = NORMAL_SPEED;
          });
          container.addEventListener('click', () => {
            if (isStopped) {
              isStopped = false;
              targetSpeed = NORMAL_SPEED;
            } else {
              isStopped = true;
              targetSpeed = STOP_SPEED;
            }
          });
        }
      }
    }, {
      threshold: 0,
      rootMargin: '0px 0px -50px 0px'
    });

    observer.observe(container);
  }

  initScrollOnView();
});

/* Testimonials slider */

// Dynamic Testimonials - DynamicTestimonials in empire.js has some breakpoints set, but no need to change if we have 3 testimonials or more.

/* CAH Button Test */